import { ColoredProfile, EventThread } from "@clockwise/web-commons/src/ui/event-thread/";
import { useReadCalendarColors } from "@clockwise/web-commons/src/util/CalendarColorsContext";
import { getOwnCalendarColor } from "@clockwise/web-commons/src/util/calendar-coloring";
import { isEmpty } from "lodash";
import React from "react";
import { useUserProfile } from "../../../../../hooks/useUserProfile";
import { RENDERED_IN } from "../../../../constants";
import {
  GQLOthersConsequenceDiffSummary,
  GQLYourConsequenceDiffSummary,
} from "../../../utils/types";
import { DiffEventCardCollapsed } from "../../diffs/DiffEventCardCollapsed";

export const ConsequencesEvents = ({
  diffs,
  isScheduleByMoving,
  viewerIsProposalOwner = true,
  variant = RENDERED_IN.AI_CHAT,
}: {
  diffs: (GQLYourConsequenceDiffSummary | GQLOthersConsequenceDiffSummary)[];
  isScheduleByMoving: boolean;
  viewerIsProposalOwner?: boolean;
  variant?: string;
}) => {
  if (isEmpty(diffs)) {
    return null;
  }

  return (
    <>
      {diffs.map((diff) => (
        <ConsequencesEvent
          key={diff.id}
          diff={diff}
          isScheduleByMoving={isScheduleByMoving}
          viewerIsProposalOwner={viewerIsProposalOwner}
          variant={variant}
        />
      ))}
    </>
  );
};

const ConsequencesEvent = ({
  diff,
  isScheduleByMoving,
  viewerIsProposalOwner,
  variant,
}: {
  diff: GQLYourConsequenceDiffSummary | GQLOthersConsequenceDiffSummary;
  isScheduleByMoving: boolean;
  viewerIsProposalOwner: boolean;
  variant: string;
}) => {
  const calendarColorMap = useReadCalendarColors();
  const { userProfile: currentUserProfile, loading: userProfileLoading } = useUserProfile();

  const coloredProfiles: ColoredProfile[] = [];
  switch (diff.__typename) {
    case "OthersConsequenceDiffSummary":
      diff.affectedAttendees.map((attendee) => {
        const color = calendarColorMap[attendee.calendarId]?.border || "";
        const profile = {
          givenName: attendee.person?.profile?.givenName || null,
          familyName: attendee.person?.profile?.familyName || null,
          externalImageUrl: attendee.person?.profile?.externalImageUrl || null,
        };
        coloredProfiles.push({ color, profile });
      });
      break;
    case "YourConsequenceDiffSummary":
      if (!userProfileLoading) {
        coloredProfiles.push({
          color: getOwnCalendarColor().border,
          profile: currentUserProfile,
        });
      }
      break;
  }

  return (
    <EventThread.Event coloredProfiles={coloredProfiles}>
      <DiffEventCardCollapsed
        action={diff.action}
        ambiguities={[]}
        id={diff.id}
        isSBM={isScheduleByMoving}
        title={diff.title}
        variant={variant}
        viewerIsProposalOwner={viewerIsProposalOwner}
      />
    </EventThread.Event>
  );
};
